import { SubsectionGroup } from '@sleepstation/components'
import propTypes from '@sleepstation/components-prop-types'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import FancyList from '../FancyList'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const FancyListTitled = ({
  items,
  title,
  id,
  dataCy,
  Group,
  baselines,
  spacing,
  kind,
  iconSize,
}) => (
  <Layout id={id} data-cy={dataCy}>
    <Group title={title}>
      <FancyList
        items={items}
        spacing={spacing}
        baselines={baselines}
        kind={kind}
        iconSize={iconSize}
      />
    </Group>
  </Layout>
)

FancyListTitled.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string,
  id: PropTypes.string,
  dataCy: PropTypes.string,
  Group: PropTypes.func,
  baselines: propTypes.numberOrArrayOfNumbers,
  spacing: propTypes.numberOrArrayOfNumbers,
  kind: PropTypes.string,
  iconSize: PropTypes.string,
}

FancyListTitled.defaultProps = {
  title: undefined,
  id: undefined,
  dataCy: undefined,
  Group: SubsectionGroup,
  baselines: undefined,
  spacing: undefined,
  kind: undefined,
  iconSize: undefined,
}

export default FancyListTitled
